import React from 'react'
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined'
import Linkify from 'react-linkify'
import { useHistory } from 'react-router-dom'
import {
  Avatar,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import { Like } from '../like'
import { IDose } from 'daily-dose-common'
import { firestore } from '../../firebase-init';
import dayjs from 'dayjs'
import pastDoseImage from '../../assets/images/past_dose.png'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
    },
    actionButtonsContainer: {
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      paddingBottom: theme.spacing(1),
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  })
)

interface IDoseItemProps {
  dose: IDose
  link?: boolean
}

const DoseItem = ({ dose, link = false }: IDoseItemProps) => {
  const classes = useStyles()
  const history = useHistory()

  const { id, circleId, name, comments, likeCount, description } = dose

  const doseRef = firestore
    .collection('circles')
    .doc(circleId)
    .collection('doses')
    .doc(id as string)

  const onGoToTodaysDoseDetailPage = () => {
    if (!link) return

    return history.push(`/my-circles/${circleId}/doses/${id}`)
  }

  if (!id) return null

  return (
    <Grid item xs={12} className="dont-break-out">
      <Card className={classes.root}>
        <CardActionArea onClick={onGoToTodaysDoseDetailPage}>
          <CardHeader
            avatar={<Avatar alt={name} src={pastDoseImage} variant="rounded" />}
            title={name}
            subheader={dayjs(dose?.activeAt?.toDate()).format('MMM D. YYYY. ')}
          />
          {description && (
            <CardContent>
              <Typography variant="body2" color="textSecondary" component="p">
                <Linkify>{description}</Linkify>
              </Typography>
            </CardContent>
          )}
        </CardActionArea>
        <CardActions>
          <Like docRef={doseRef} likeCount={likeCount} size="small" />
          <IconButton
            aria-label="comment"
            onClick={onGoToTodaysDoseDetailPage}
            size="small"
          >
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginRight: '4px' }}
            >
              {comments > 0 && `${comments}`}
            </Typography>
            <CommentOutlinedIcon fontSize="inherit" />
          </IconButton>
        </CardActions>
      </Card>
    </Grid>
  )
}

export default DoseItem
